export default "<app-intro></app-intro>\r\n<app-titles></app-titles>\r\n"